import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./button.css";


const STYLE_TYPE_CLASSES = {
    primary: styles.primary,
    secondary: styles.secondary,
    tertiary: styles.tertiary,
    "temp-grey": styles.tempGrey,
};

function disabledCB(event) {
    event.preventDefault();
}

/** BUTTONS FOR THE BUTTON GOD */
function Button({ className, element, fullHeight, fullWidth, openInNewTab, styleType, ...props }) {
    let Component = props.href ? "a" : "button";
    if (element) {
        Component = element;
    }
    const typeClass = STYLE_TYPE_CLASSES[styleType];
    if (!typeClass) {
        throw new Error(`Unknown type ${styleType}!`);
    }
    props.className = classnames(className, styles.button, typeClass, {
        [styles.fullWidth]: fullWidth,
        [styles.fullHeight]: fullHeight,
        [styles.disabled]: props.disabled,
    });

    if (props.href) {
        props.target = openInNewTab ? "_blank" : "_self";
    }
    if (props.disabled) {
        props.onClick = disabledCB;
    }

    return <Component {...props} />;
}

export default Button;

Button.propTypes = {
    /** What goes in the button */
    children: PropTypes.node.isRequired,
    /** classname */
    className: PropTypes.string,
    /** Allows you to override what HTML element the button renders as */
    element: PropTypes.oneOf(["a", "button", "span"]),
    /** Prevent button being clickable (& visual state) */
    disabled: PropTypes.bool,
    /** Button grows horizontally to fit its container */
    fullWidth: PropTypes.bool,
    /** Button grows vertically to fit its container */
    fullHeight: PropTypes.bool,
    /** If this button should be a link, set this to where it should go */
    href: PropTypes.string,
    /** Event handler */
    onClick: PropTypes.func,
    /** If this button is a link, open in a _blank window */
    openInNewTab: PropTypes.bool,
    /** What style this button should show as */
    styleType: PropTypes.oneOf(["primary", "secondary", "tertiary", "temp-grey"]).isRequired,
};
